<div bsModal #plantSelectorTable="bs-modal" class="modal fade" tabindex="-1" role="dialog"
    aria-labelledby="plantSelectorTable" aria-hidden="true" [config]="{backdrop: false}">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header bold">

                <span class="col-sm-20">
                    {{ l('SelectPlants')}}

                </span>

                <button [disabled]="saving" type="button" class="btn btn-default" *ngIf="!addManualPlant"
                    (click)="addManualFlagUpdate()" data-toggle="popover" data-trigger="hover" data-html="true"
                    [popover]="popTemplate" triggers="mouseenter:mouseleave">{{l("AddManualPlants")}}

                    <ng-template #popTemplate>
                        <div>{{l("AddManualPlantToolTip")}}</div>
                    </ng-template>

                </button>
                <button [disabled]="saving" type="button" class="btn btn-default" *ngIf="addManualPlant"
                    (click)="addManualFlagUpdate()" data-html="true">
                    <i class="la la-arrow-left"></i> {{ l('Back') }}
                </button>


            </div>
            <div class="modal-body">

                <div class="add-plants" *ngIf="addManualPlant">

                    <table class="table table-borderless table-md">
                        <thead>
                            <tr>
                                <th style="padding-left: 9px;">{{ l("SerialNumber") }}</th>
                                <th>{{ l("Name") }}</th>
                                <th>{{ l("Supplier") }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <ng-container *ngFor="let aplant of this.addedManualPlants">
                                <tr>
                                    <td>
                                        <input [(ngModel)]="aplant.serialNumber" class="form-control form-control-sm"
                                            type="text" required>
                                        <div class="Validation-Text-Color" *ngIf="!isInvalidSerialNumber(aplant)">
                                            {{ l("ValidationError") }}
                                        </div>
                                    </td>
                                    <td>
                                        <input [(ngModel)]="aplant.description" class="form-control form-control-sm"
                                            type="text">
                                    </td>
                                    <td>
                                        <input [(ngModel)]="aplant.vendorName" class="form-control form-control-sm"
                                            type="text">
                                    </td>
                                    <td>
                                        <button *ngIf="!isAllocationSheet()" class="btn btn-sm"
                                            ng-disabled="checkSavedManual(aplant)"
                                            (click)="removeManualPlantItem(aplant)">
                                            <i class="fa fa-trash"></i>
                                        </button>
                                    </td>
                                </tr>
                            </ng-container>
                        </tbody>
                    </table>

                    <div style="padding-left: 9px; padding-bottom: 10px;">
                        <button [disabled]="saving" type="button" class="btn btn-default"
                            (click)="addAddManual()">{{l("Add")}}</button>
                    </div>

                </div>

                <div class="select-plants" *ngIf="!addManualPlant">

                    <plant-table-filter (onFiltersChange)="filtersChange($event)"></plant-table-filter>

                    <table class="table table-borderless table-md">
                        <thead>
                            <tr>
                                <th>{{ l("Description") }}</th>
                                <th>{{ l("Location") }}</th>
                                <th>{{ l("Supplier") }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="d-block coloured">
                                <td colspan="3">
                                    <label class="label-color">{{ l("Recent") }} </label>
                                    <button [disabled]="saving" type="button" class="btn btn-link"
                                        (click)="ClearRecent()">{{l("Clear")}}</button>
                                </td>
                            </tr>
                            <ng-container *ngFor="let plant of this.filteredPlants">
                                <tr *ngIf="plant.wasRecentlyAssigned && plant.filterShow"
                                    (click)="selectPlant(plant, !plant.selected)">
                                    <td>
                                        <div class="row">
                                            <div class="col-sm-1">
                                                <i *ngIf="plant.selected == true"
                                                    class="fas fa-check-square main-color cb mr-2"></i>
                                                <i *ngIf="plant.selected == false" class="fas fa-square cb mr-2"></i>

                                            </div>
                                            <div class="col-sm-10">
                                                {{ plant.description }}
                                                <ng-container *ngIf="plant.serialNumber">({{plant.serialNumber.trim()}})
                                                </ng-container>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        {{ plant.location }}
                                    </td>
                                    <td>
                                        {{ plant.supplierName }}
                                    </td>
                                </tr>
                            </ng-container>
                            <tr *ngIf="!checkFilteredPlantNull(this.filteredPlants)" class="d-block coloured">
                                <td colspan="3">
                                    <label class="label-color">{{ l("All") }} </label>
                                </td>
                            </tr>
                            <tr *ngIf="checkFilteredPlantNull(this.filteredPlants)"><td colspan="3">{{ l('NoResultsFound') }}</td></tr>
                            <ng-container *ngFor="let plant of this.filteredPlants">
                                <tr *ngIf="!plant.wasRecentlyAssigned && plant.filterShow"
                                    (click)="selectPlant(plant, !plant.selected)">
                                    <td>
                                        <div class="row">
                                            <div class="col-sm-1">
                                                <i *ngIf="plant.selected == true"
                                                    class="fas fa-check-square main-color cb  mr-2"></i>
                                                <i *ngIf="plant.selected == false" class="fas fa-square cb  mr-2"></i>
                                            </div>
                                            <div class="col-sm-10">
                                                {{ plant.description }}
                                                <ng-container *ngIf="plant.serialNumber">(</ng-container>{{
                                                plant.serialNumber.trim() }}<ng-container *ngIf="plant.serialNumber">)
                                                </ng-container>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        {{ plant.location }}
                                    </td>
                                    <td>
                                        {{ plant.supplierName }}
                                    </td>
                                </tr>
                            </ng-container>
                        </tbody>
                    </table>

                </div>
            </div>

            <div class="modal-footer">
                <button [disabled]="saving" type="button" class="btn btn-primary"
                    (click)="close()">{{this.addManualPlant? l("Save") : l("Close")}}</button>
            </div>

        </div>
    </div>
</div>
<table class="table table-borderless rows-no-padding assign-plants-table">
    <tr *ngFor="let plant of getSelectedPlant(); let i = index" class="table-row">
        <td class="align-middle display-table-items-center">
            <i class="fas fa-check-square main-color margin-right-5"></i>
            {{ plant.plantDetails.description }}
            <ng-container *ngIf="plant.plantDetails.serialNumber">({{plant.plantDetails.serialNumber.trim()}})
            </ng-container>
        </td>

        <td class="align-middle display-table-items-center">
            <div *ngIf="plant.plantDetails.isManualPlant">
                <i class="fa fa-hand-point-up" data-toggle="popover" data-trigger="hover" data-html="true"
                    [popover]="popTemplate" triggers="mouseenter:mouseleave"></i>
                <ng-template #popTemplate>
                    <div [innerHtml]="getUserToolTip(plant)"></div>
                </ng-template>
            </div>
        </td>

        <td class="align-middle text-sm-right display-table-items-center">
                <input *ngIf="!isAllocationSheet()"
                    [(ngModel)]="plant.actualHours"
                    (blur)="updateAllocatedPlantList($event)"
                    [disabled]="controlDisabled"
                    class="form-control form-control-sm float-right"
                    style="max-width: 80px"
                    inputmode="numeric"
                    step=".01"
                    onKeyPress="if((!this.value.includes('.') && this.value.length >= 4 && event.key !== '.') || (this.value.includes('.') && this.value.split('.')[1].length >= 4)) return false"
                    type="number" min="1" max="24" required />
                <span *ngIf="isAllocationSheet()">
                    {{ plant.actualHours }}
                </span>
                <div>hrs</div>

        </td>

        <td class="align-middle cell-btn-delete display-table-items-center">
            <button *ngIf="!isAllocationSheet()" class="btn btn-sm" [disabled]="controlDisabled"
                (click)="removeItem(plant.plantId)">
                <i class="fa fa-trash" data-toggle="popover" data-trigger="hover" data-html="true"
                    [popover]="popTemplate" triggers="mouseenter:mouseleave"></i>

                <ng-template #popTemplate>
                    <div [innerHtml]="getPlantDeleteToolTip(plant)"></div>
                </ng-template>

            </button>
        </td>
    </tr>
</table>
<button class="btn btn-default" *ngIf="!isAllocationSheet()" [disabled]="controlDisabled" (click)="show()">
    <i class="fas fa-plus"></i> {{ l("Add") }}
</button>
<div class="validation-msg" *ngIf="showError() && !anyResourceSelected">{{ l('MinResourceSelectionCriteria') }}</div>
